import { UntypedFormGroup, UntypedFormControl, Validators, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { CustomValidator } from '../../../validators/custom.validator';

export class OrderDeliveryStatusesForm extends UntypedFormGroup {
  constructor() {
    super({
      dayToDisplay: new UntypedFormControl(null),
    });
  }

  forAdd() {
    return this;
  }
}
